export default __webpack_public_path__ + "static/media/copy-icon.a8ac88c2.svg";